import styled from 'styled-components'
import JobThumb from './JobThumb'
import { RootState, useAppSelector } from '../../store'
import { useEffect, useState } from 'react'
import { JobSimple } from '../../models/JobSimple'

function RecentJobs() {
  const recentJobs = useAppSelector(
    (state: RootState) => state.user.me.recentJobs
  )
  const allJobs = useAppSelector((state: RootState) => state.main.jobs)

  const [jobs, setJobs] = useState<JobSimple[]>([])

  useEffect(() => {
    if (allJobs.length === 0 || !recentJobs || recentJobs === '') {
      console.log('not set')
      return
    }

    const jobIds = JSON.parse(recentJobs)

    setJobs(
      jobIds
        .map((jobId: number) => allJobs.find((job) => job.id === jobId))
        .reverse()
    )
  }, [recentJobs, allJobs])

  return (
    <Container>
      {recentJobs && recentJobs.length > 0 && (
        <>
          <Header>최근 본 직업</Header>
          <JobThumbList>
            {jobs.length > 0 &&
              jobs.map((job, index) => (
                <JobThumb
                  key={index}
                  image={job.photo}
                  name={job.name}
                  id={job.id}
                />
              ))}
          </JobThumbList>
        </>
      )}
    </Container>
  )
}

const Container = styled.div`
  grid-area: rightside;

  @media (max-width: 768px) {
    margin-bottom: 80px;
  }
`

const Header = styled.div`
  text-align: center;
  background-color: #eee;
  padding: 8px 0;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.1rem;
`
const JobThumbList = styled.div`
  background-color: #f2f2f2;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    column-gap: 2px;
    margin: 2px;
    & > div {
      width: 24%;
    }
  }
`

export default RecentJobs
